export default {
  404: {
    title: '<span class="accent">404</span> Pagina non trovata',
    text: 'Sembra che la pagina che stavi cercando non esista più o sia stata spostata.<br /> Non preoccuparti, ti aiuteremo a trovare la strada di casa.',
  },
  500: {
    title: '<span class="accent">500</span> Errore interno del server',
    text: 'Ci scusiamo, si è verificato un errore interno. <br />Stiamo lavorando per risolvere il problema il prima possibile. <br /> Prova a tornare alla homepage o riprova più tardi.',
  },
  suggestions: {
    title: 'Ecco alcune cose che puoi fare:',
    backhomeCta: 'Torna alla Homepage',
    backhomeText:
      'iniziare da capo e conoscere tutte le sezioni del nostro sito.',
    contactsCta: 'Contattaci',
    contactsText: 'se hai bisogno di assistenza, non esitare a contattarci.',
  },
}
